var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.currentTime?.total <= _vm.redTextTime ? 'error--text' : '',domProps:{"textContent":_vm._s(_vm.timerView)}})
}
var staticRenderFns = []

export { render, staticRenderFns }